import type { ArenaTableColumns } from '@library/types/arenaContest';
import type { TableColumn } from '@library/types/utils';

export const ARENA_TABLE_HEADER: Array<TableColumn<ArenaTableColumns>> = [
  {
    column: 'rank',
    essential: true,
    label: 'Rank',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'memberId',
    essential: true,
    label: 'Member ID',
    sortEnabled: false,
    width: 'w-[15%] '
  },
  {
    column: 'picks',
    essential: true,
    label: 'Picks',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'score',
    essential: true,
    label: 'Score',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'entryResult',
    essential: true,
    label: 'Entry Result',
    sortEnabled: false,
    width: 'w-[15%]'
  },
  {
    column: 'correctDemons',
    essential: true,
    label: 'Correct Demons',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'correctGoblins',
    essential: true,
    label: 'Correct Goblins',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'tiedDnp',
    essential: true,
    label: 'Tied/DNP',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'reboots',
    essential: true,
    label: 'Reboots',
    sortEnabled: false,
    width: 'w-[8%]'
  },
  {
    column: 'result',
    essential: true,
    label: 'Contest Result',
    sortEnabled: false,
    width: 'w-[14%]'
  }
];

export const ARENA_TABLE_ORDERED_COLUMNS = [
  // intentionally not alphabetical - the order of the columns is important
  'rank',
  'memberId',
  'picks',
  'score',
  'entryResult',
  'correctDemons',
  'correctGoblins',
  'tiedDnp',
  'reboots',
  'result'
];
